const afternoon = ['09-22-06_0732.JPG',
'12-16-05_1630.JPG',
'19-06-08_2010.JPG',
'IMG_0074.JPG',
'IMG_0082.JPG',
'IMG_0114.JPG',
'IMG_0379.JPG',
'IMG_0497.JPG',
'IMG_0614.JPG',
'IMG_0629.JPG',
'IMG_0636.JPG',
'IMG_0639.JPG',
'IMG_0641.JPG',
'IMG_0766.JPG',
'IMG_0799.JPG',
'IMG_0808.JPG',
'IMG_0812.JPG',
'IMG_0816.JPG',
'IMG_0915.JPG',
'IMG_0933.JPG',
'IMG_0946.JPG',
'IMG_1174.JPG',
'IMG_1176.JPG',
'IMG_1264.JPG',
'IMG_1330.JPG',
'IMG_1453.JPG',
'IMG_1591.JPG',
'IMG_1592.JPG',
'IMG_1600.JPG',
'IMG_1602.JPG',
'IMG_1631.JPG',
'IMG_1633.JPG',
'IMG_1748.JPG',
'IMG_1780.JPG',
'IMG_1785.JPG',
'IMG_1796.JPG',
'IMG_1800.JPG',
'IMG_1818.JPG',
'IMG_1823.JPG',
'IMG_1946.JPG',
'IMG_1947.JPG',
'IMG_2029.JPG',
'IMG_2244.JPG',
'IMG_2273.JPG',
'IMG_2289.JPG',
'IMG_2514.JPG',
'IMG_2539.JPG',
'IMG_2546.JPG',
'IMG_2556.JPG',
'IMG_2559.JPG',
'IMG_2567.JPG',
'IMG_2571.JPG',
'IMG_2585.JPG',
'IMG_2592.JPG',
'IMG_2598.JPG',
'IMG_2646.JPG',
'IMG_2651.JPG',
'IMG_2652.JPG',
'IMG_2658.JPG',
'IMG_2659.JPG',
'IMG_2840.JPG',
'IMG_2861.JPG',
'IMG_2890.JPG',
'IMG_2894.JPG',
'IMG_2896.JPG',
'IMG_3006.JPG',
'IMG_3008.JPG',
'IMG_3315.JPG',
'IMG_3449.JPG',
'IMG_3571.JPG',
'IMG_3594.JPG',
'IMG_3700.JPG',
'IMG_3701.JPG',
'IMG_3840.JPG',
'IMG_4286.JPG',
'IMG_4381.JPG',
'IMG_4406.JPG',
'IMG_4408.JPG',
'RebelXS_IMG_0301.JPG',
'RebelXS_IMG_0311.JPG',
'RebelXS_IMG_0312.JPG',
'RebelXS_IMG_0316.JPG',
'RebelXS_IMG_0340.JPG',
'RebelXS_IMG_0393.JPG',
'RebelXS_IMG_0890.JPG',
'RebelXS_IMG_1650.JPG',
'RebelXS_IMG_1704.JPG',
'RebelXS_IMG_1798.JPG',
'RebelXS_IMG_2105.JPG',
'RebelXS_IMG_2149.JPG',
'RebelXS_IMG_2156.JPG',
'RebelXS_IMG_2500.JPG',
'RebelXS_IMG_2554.JPG',
'RebelXS_IMG_2600.JPG',
'RebelXS_IMG_2976.JPG',
'RebelXS_IMG_3180.JPG',
'RebelXS_IMG_3264.JPG',
'RebelXS_IMG_3456.JPG',
'STC_3239.JPG',
'STG_3243.JPG',
'iPhone2G_IMG_0044.JPG',
'iPhone2G_IMG_0056.JPG',
'iPhone2G_IMG_0211.JPG',
'iPhone2G_IMG_0234.JPG',
'iPhone2G_IMG_0239.JPG',
'iPhone2G_IMG_0242.JPG',
'iPhone2G_IMG_0248.JPG',
'iPhone2G_IMG_0251.JPG',
'iPhone2G_IMG_0347.JPG',
'iPhone2G_IMG_0453.JPG'];

export default afternoon;